/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {signal} from '@preact/signals-react';
import {CVSAssetType} from '@ion/core/src/types/entities';

export type StreetViewAsset = CVSAssetType | null;

/**
 * Defines the asset whose Street View dialog is open, or `null` when no dialog
 * is open. Held in a signal rather than the tracking Redux slice because the
 * selection is transient view state that no reducer, saga or selector needs to
 * observe.
 */
export const streetViewAsset = signal<StreetViewAsset>(null);

/**
 * Opens the Street View dialog for an asset, or closes it when passed `null`.
 *
 * ```typescript
 *
 *   import {setStreetViewAsset} from '@/components/streetview/store';
 *   ...
 *
 *   setStreetViewAsset(asset);
 *
 * ```
 *
 * @param asset the asset to show a panorama for, or `null` to close
 */
export const setStreetViewAsset = (asset: StreetViewAsset): void => {
  streetViewAsset.value = asset;
};
